import React, { useState, useEffect } from 'react';
import { Bar, defaults, Chart } from 'react-chartjs-2';
import _ from 'lodash';

function AgeChart(props) {
	useEffect(() => {
		Chart.pluginService.register({
			beforeDraw: (chartInstance) => {
				const array = [];
				const values = chartInstance.data.datasets;
				_.forEach(values, (o) => {
					_.forEach(o.data, (d) => {
						array.push(d);
					});
				});
				const { ctx } = chartInstance.chart;
				ctx.fillText(`Casos: ${_.sum(array)}`, 0, 10);
			},
		});
	}, []);

	_.merge(defaults, {
		scale: {
			scaleLabel: {
				padding: {
					bottom: 0,
				},
			},
			ticks: {
				autoSkipPadding: 5,
				maxRotation: 0,
				beginAtZero: true,
			},
			gridLines: {
				color: 'rgba(0,0,0,0.05)',
				zeroLineColor: 'rgba(0,0,0,0.1)',
			},
		},
		global: {
			layout: {
				padding: { top: 0, right: 0, bottom: 0, left: 0 },
			},
			defaultFontColor: `rgba(0,0,0,0.5)`,
			defaultFontFamily: `Lato,'Helvetica Neue',Arial,Helvetica,sans-serif`,
			defaultFontSize: 10,
			tooltips: {
				backgroundColor: '#2d2d2d',
				borderColor: 'rgba(255,255,255,0.1)',
				borderWidth: 1,
				bodyFontColor: `rgba(255,255,255,0.5)`,
				bodySpacing: 5,
				cornerRadius: 3,
				xPadding: 10,
				yPadding: 10,
			},
			legend: {
				display: false,
				labels: {
					usePointStyle: true,
					fontStyle: 'bold',
					fontColor: 'rgba(0,0,0,0.75)',
				},
			},
			elements: {
				line: {
					borderColor: '#f9886c',
					borderCapStyle: 'butt',
					borderJoinStyle: 'miter',
					borderWidth: 2,
					capBezierPoints: true,
					fill: false,
					tension: 0.4,
				},
				point: {
					backgroundColor: '#ffffff',
					borderColor: '#f9886c',
					borderWidth: 2,
					hitRadius: 1,
					hoverBorderWidth: 2,
					hoverBorderColor: '#f9886c',
					hoverRadius: 6,
					pointStyle: 'circle',
					radius: 4,
				},
				rectangle: {
					backgroundColor: 'rgba(249,136,108,0.85)',
					borderColor: 'rgba(249,136,108,0.95)',
					borderWidth: 1,
				},
			},
			maintainAspectRatio: false,
			title: {
				display: true,
				fullWidth: true,
				text: 'Chart Title',
				fontColor: 'rgba(0,0,0,0.75)',
			},
		},
		line: {
			scales: {
				xAxes: [
					{
						scaleLabel: {
							display: false,
						},
						gridLines: {
							display: false,
						},
					},
				],
			},
			spanGaps: true,
		},
		bubble: {
			scales: {
				xAxes: [
					{
						scaleLabel: {
							display: false,
						},
						gridLines: {
							display: false,
						},
					},
				],
			},
		},
		bar: {
			scales: {
				xAxes: [
					{
						scaleLabel: {
							display: false,
						},
						gridLines: {
							display: false,
						},
					},
				],
			},
		},
	});

	const [data, setData] = useState({
		masculino: {
			'15 a 24': 0,
			'25 a 34': 0,
			'35 a 44': 0,
			'45 a 54': 0,
			'55 a 64': 0,
			'65+': 0,
		},
		femenino: {
			'15 a 24': 0,
			'25 a 34': 0,
			'35 a 44': 0,
			'45 a 54': 0,
			'55 a 64': 0,
			'65+': 0,
		},
	});

	const aggregate = (age, gender) => {
		if (gender === 'Masculino') {
			if (age === '15 a 24') {
				setData((prevState) => ({
					masculino: {
						...prevState.masculino,
						'15 a 24': prevState.masculino['15 a 24'] + 1,
					},
					femenino: {
						...prevState.femenino,
					},
				}));
			}
			if (age === '25 a 34') {
				setData((prevState) => ({
					masculino: {
						...prevState.masculino,
						'25 a 34': prevState.masculino['25 a 34'] + 1,
					},
					femenino: {
						...prevState.femenino,
					},
				}));
			}
			if (age === '35 a 44') {
				setData((prevState) => ({
					masculino: {
						...prevState.masculino,
						'35 a 44': prevState.masculino['35 a 44'] + 1,
					},
					femenino: {
						...prevState.femenino,
					},
				}));
			}
			if (age === '45 a 54') {
				setData((prevState) => ({
					masculino: {
						...prevState.masculino,
						'45 a 54': prevState.masculino['45 a 54'] + 1,
					},
					femenino: {
						...prevState.femenino,
					},
				}));
			}
			if (age === '55 a 64') {
				setData((prevState) => ({
					masculino: {
						...prevState.masculino,
						'55 a 64': prevState.masculino['55 a 64'] + 1,
					},
					femenino: {
						...prevState.femenino,
					},
				}));
			}
			if (age === '65+') {
				setData((prevState) => ({
					masculino: {
						...prevState.masculino,
						'65+': prevState.masculino['65+'] + 1,
					},
					femenino: {
						...prevState.femenino,
					},
				}));
			}
		} else if (gender === 'Femenino') {
			if (age === '15 a 24') {
				setData((prevState) => ({
					masculino: {
						...prevState.masculino,
					},
					femenino: {
						...prevState.femenino,
						'15 a 24': prevState.femenino['15 a 24'] + 1,
					},
				}));
			}
			if (age === '25 a 34') {
				setData((prevState) => ({
					masculino: {
						...prevState.masculino,
					},
					femenino: {
						...prevState.femenino,
						'25 a 34': prevState.femenino['25 a 34'] + 1,
					},
				}));
			}
			if (age === '35 a 44') {
				setData((prevState) => ({
					masculino: {
						...prevState.masculino,
					},
					femenino: {
						...prevState.femenino,
						'35 a 44': prevState.femenino['35 a 44'] + 1,
					},
				}));
			}
			if (age === '45 a 54') {
				setData((prevState) => ({
					masculino: {
						...prevState.masculino,
					},
					femenino: {
						...prevState.femenino,
						'45 a 54': prevState.femenino['45 a 54'] + 1,
					},
				}));
			}
			if (age === '55 a 64') {
				setData((prevState) => ({
					masculino: {
						...prevState.masculino,
					},
					femenino: {
						...prevState.femenino,
						'55 a 64': prevState.femenino['55 a 64'] + 1,
					},
				}));
			}
			if (age === '65+') {
				setData((prevState) => ({
					masculino: {
						...prevState.masculino,
					},
					femenino: {
						...prevState.femenino,
						'65+': prevState.femenino['65+'] + 1,
					},
				}));
			}
		}
	};

	useEffect(() => {
		if (props.data) {
			setData({
				masculino: {
					'15 a 24': 0,
					'25 a 34': 0,
					'35 a 44': 0,
					'45 a 54': 0,
					'55 a 64': 0,
					'65+': 0,
				},
				femenino: {
					'15 a 24': 0,
					'25 a 34': 0,
					'35 a 44': 0,
					'45 a 54': 0,
					'55 a 64': 0,
					'65+': 0,
				},
			});

			_.forEach(props.data, (e) => {
				aggregate(e.edad, e.genero);
			});
		}
	}, [props.data]);

	return (
		<Bar
			data={{
				labels: ['15 a 24', '25 a 34', '35 a 44', '45 a 54', '55 a 64', '65+'],
				datasets: [
					{
						label: 'Masculino',
						data: [
							data.masculino['15 a 24'],
							data.masculino['25 a 34'],
							data.masculino['35 a 44'],
							data.masculino['45 a 54'],
							data.masculino['55 a 64'],
							data.masculino['65+'],
						],
					},
					{
						label: 'Femenino',
						data: [
							data.femenino['15 a 24'],
							data.femenino['25 a 34'],
							data.femenino['35 a 44'],
							data.femenino['45 a 54'],
							data.femenino['55 a 64'],
							data.femenino['65+'],
						],
						backgroundColor: '#8a8acb',
						borderColor: '#8a8acb',
					},
				],
			}}
			options={{
				title: {
					text: ['Género y Edad', 'Distribución de eventos por género y edad'],
				},
				tooltips: {
					callbacks: {
						label(tooltipItem, d) {
							const dataset = d.datasets[tooltipItem.datasetIndex];
							const total = dataset.data.reduce(
								(previousValue, currentValue) => {
									return previousValue + currentValue;
								}
							);
							const currentValue = dataset.data[tooltipItem.index];
							const percentage = Math.floor((currentValue / total) * 100 + 0.5);

							return `${currentValue} (${percentage}%)`;
						},
						title(tooltipItem, d) {
							return d.labels[tooltipItem[0].index];
						},
					},
				},
			}}
			legend={{
				display: true,
				position: 'right',
				align: 'start',
				labels: {
					usePointStyle: true,
				},
			}}
		/>
	);
}

export default AgeChart;
